import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { investorApi } from "../../api/api";
import GradientButton from "../common/GradiantButton";
import PropertyList from "../Header/Property/PropertyList";
import {
  Typography,
  Box,
  TextField,
  Paper,
  Autocomplete,
  Fab,
  useMediaQuery,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useMemo } from "react";


const HomeSearch = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [mode, setMode] = useState("project");
  const [location, setLocation] = useState("");
  const [keyword, setKeyword] = useState("");
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);

  const userId = useSelector((data) => data.user.userId);
  const theme = useSelector((data) => data.themeValue.colors);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  const formatText = (text = "") =>
  text
    .toLowerCase()
    .split(" ")
    .map((word) =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // debugger
        const response = await investorApi.getAllPropertiesAndProjects();
        
        // debugger
        setProperties(response.data);
        setLoading(false);
      } catch (error) { 
        console.error("Error fetching property data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



const locationCity = useMemo(() => {
  const cityMap = new Map();

  properties.forEach((item) => {
    if (item?.city) {
      const trimmedCity = item.city.trim();
      const normalizedCity = trimmedCity.toLowerCase();

      if (!cityMap.has(normalizedCity)) {
        cityMap.set(normalizedCity, formatText(trimmedCity));
      }
    }
  });

  return Array.from(cityMap.values());
}, [properties]);



const addressOptions = useMemo(() => {
  const addressMap = new Map();

  properties.forEach((p) => {
    if (p?.address && p?.city) {
      const trimmedAddress = p.address.trim();
      const trimmedCity = p.city.trim();

      const normalizedKey =
        trimmedAddress.toLowerCase() + "_" + trimmedCity.toLowerCase();

      if (!addressMap.has(normalizedKey)) {
        addressMap.set(normalizedKey, {
          label: `${formatText(trimmedAddress)}, ${formatText(trimmedCity)}`,
          address: formatText(trimmedAddress),
          city: formatText(trimmedCity),
        });
      }
    }
  });

  return Array.from(addressMap.values());
}, [properties]);





  const handleSearch = (selectedCity = "") => {
    setError("");
    const finalLocation = selectedCity || location;
    const selectedAddress = keyword.split(",")[0]?.trim() || "";
    const selectedCityFromKeyword = keyword.split(",")[1]?.trim() || "";

    navigate("/search-properties", {
      state: {
        // isAuthenticated,
        address: selectedAddress,
        city: finalLocation || selectedCityFromKeyword,
        // SelectLocation: finalLocation,
        // type: mode,
      },
    });
  };

  return (
    <>
      <Box >
        {/* Hero Section */}
        {/* <Box
          sx={{
            width: "100%",
            position: "relative",
            backgroundImage: {
              sm: `url("/Jemins_banner_desktop.png")`,
              xs: `url("jemins banner.png")`

            },
            backgroundSize: {
              xs: "cover", //  shows full mobile image (no cropping)
              sm: "cover",   //  fills background nicely on desktop
            },
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: {
              xs: "80px",
              sm: "340px", //  matches your desktop image height
            },
            display: {
              xs: "none",
              sm: "flex", //  matches your desktop image height
            },
            justifyContent: "flex-end",
            alignItems: "flex-start",
            zIndex: 1,
            marginBottom: 8,
            transition: "background-image 0.5s ease-in-out",
          }}
        > */}

        <Box
  sx={{
    width: "100%",
    position: "relative",
    zIndex: 1, // 👈 AppBar (1300) vida kammi
    marginBottom:10,
    backgroundImage: {
      sm: `url("/banner.png")`,
      xs: `url("jemins banner.png")`,
    },
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",

    minHeight: {
      xs: "80px",
      sm: "340px",
    },

    display: {
      xs: "none",
      sm: "flex",
    },
  }}
>
          <Paper
            elevation={3}
            sx={{
              zIndex: 10,
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              bottom: { sm: "-15%", xs: "-70%" },
              padding: { xs: 2, sm: 3 },
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              gap: 2,
              maxWidth: "900px",
              mx: "auto",
              flexDirection: { xs: "column", sm: "row" },
              width: { xs: "calc(100vw - 32px)", sm: "100%" },
              boxSizing: "border-box",
              boxShadow: { xs: 2, sm: 3 },
              backgroundColor: theme.screen_background || "#fff",
            }}
          >
            {/* City Dropdown */}
            <Autocomplete
              freeSolo
              options={locationCity}
              value={location}
              sx={{ width: "20%", display: { xs: "none", sm: "block" } }}
              onChange={(e, newValue) => setLocation(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="City"
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      "& fieldset": { border: "1px solid #ddd" },
                      "&:hover fieldset": { borderColor: "#007bff" },
                      "&.Mui-focused fieldset": { borderColor: "#007bff" },
                    },
                  }}
                />
              )}
            />

            {/* Search Field */}
            <Autocomplete
              freeSolo
              options={addressOptions}
              inputValue={keyword}
              onInputChange={(event, newInputValue) => setKeyword(newInputValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={isMobile ? "Search by City..." : "Search by Area..."}
                  variant="outlined"
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                    },
                    backgroundColor: "white",
                    borderRadius: "12px",
                  }}
                />
              )}
              sx={{
                flex: 2,
                width: { xs: "100%" },
                display: { xs: "none", sm: "block" },
              }}
            />

            {/* Mobile Search */}
            <Autocomplete
              freeSolo
              options={locationCity}
              value={location}
              onChange={(e, newValue) => {
                setLocation(newValue || "");
                if (newValue) handleSearch(newValue);
              }}
              onInputChange={(e, newValue) => setLocation(newValue || "")}
              sx={{ width: "100%", display: { xs: "block", sm: "none" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search by City..."
                  variant="outlined"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch(location || e.target.value);
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      "& fieldset": { border: "1px solid #ddd" },
                      "&:hover fieldset": { borderColor: "#007bff" },
                      "&.Mui-focused fieldset": { borderColor: "#007bff" },
                    },
                  }}
                />
              )}
            />

            {/* Search Button */}
            <GradientButton
              text="Search"
              onClick={() => handleSearch()}
              width={{ xs: "100%", sm: "150px" }}
              sx={{
                display: { xs: "none", sm: "block" },
                borderRadius: "12px",
                fontSize: "1rem",
                fontWeight: "600",
              }}
            />
          </Paper>

          {error && (
            <Typography
              sx={{
                color: "red",
                marginTop: "0.5rem",
                fontWeight: "500",
                textAlign: "center",
                width: "100%",
                px: 2,
              }}
            >
              {error}
            </Typography>
          )}
        </Box>

        {isMobile && (
          <Paper
            elevation={3}
            sx={{
              zIndex: 10,
              padding: 2,
              borderRadius: "20px",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "calc(100vw - 32px)",
              mx: "auto",
              boxShadow: 2,
              backgroundColor: theme.screen_background || "#fff",
              marginBottom:"10px",
              marginTop:5
            }}
          >
            {/* Mobile Search */}
            <Autocomplete
              freeSolo
              options={locationCity}
              value={location}
              onChange={(e, newValue) => {
                setLocation(newValue || "");
                if (newValue) handleSearch(newValue);
              }}
              onInputChange={(e, newValue) => setLocation(newValue || "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search by City..."
                  variant="outlined"
                />
              )}
            />
          </Paper>
        )}

      </Box>

      <PropertyList />
      {/* <AppDownloadSection/> */}
      {/* 🆙 Scroll-to-Top Button */}
      {showScrollButton && (
        <Fab
          color="primary"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 30,
            right: 30,
            zIndex: 2000,
            background: `linear-gradient(90deg, ${theme.primary_gradient_start_color}, ${theme.primary_gradient_end_color})`,
            color: "#fff",
            "&:hover": { opacity: 0.9 },
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      )}
    </>
  );
};

export default HomeSearch;